import React, { useEffect, lazy, Suspense } from 'react';
import './Table.scss';
import Table from 'react-bootstrap/Table';
import { connect } from 'react-redux';
import { fetchTable } from '../../store/actions/table';
import Spinner from '../common/Spinner';
import { Link } from 'react-router-dom';
import DownloadFile from '../../components/common/DownloadFile';
import OpenFile from '../../components/common/OpenFile';
import ReactGA from 'react-ga';
import { language } from '../../common/language';
import { removeTrailingForwardSlashes } from '../../common/utils';

export const TableHeader = lazy(() => import('./header/TableHeader'));
export const TableSection = lazy(() => import('./body/sections/TableSection'));
export const SummaryRow = lazy(() => import('./body/SummaryRow'));
export const Description = lazy(() => import('../common/Description'));
export const Relations = lazy(() => import('../common/Relations'));

/* eslint-disable react/prop-types */
export const TableInstance = props => {
  let headerItems;
  let tableSections;
  let mainSummaryRow;
  let linkToTable = '';

  const { fetchTable, tableData } = props;

  useEffect(() => {
    fetchTable(props.selectedTable);
  }, [props.selectedTable, fetchTable]);

  const handleVariationChange = selectedVariation => {
    props.selectedTable.variation = selectedVariation;
    fetchTable(props.selectedTable);
  };

  if (tableData.table) {
    headerItems = tableData.table.header;
    tableSections = tableData.table.sections.map((value, index) => {
      return <TableSection key={index} section={value} />;
    });
    mainSummaryRow = tableData.table.summary;

    linkToTable = removeTrailingForwardSlashes(window.location.pathname);
    if (props.selectedTable.variation) {
      linkToTable += `/tabell/${props.selectedTable.label}/variant/${props.selectedTable.variation}`;
    } else {
      linkToTable += `/tabell/${props.selectedTable.label}`;
    }
  }

  return (
    <React.Fragment>
      <Suspense fallback={<Spinner />}>
        <div className="link-container">
          <Link
            to={linkToTable}
            className="mr-3 open-table-new-tab"
            onClick={ev => {
              ReactGA.event({
                category: `${props.selectedTable.shortName}' '${props.selectedTable.year}`,
                action: 'Open details view',
                label: 'Table ' + props.selectedTable.label
              });
              ev.preventDefault();
              window.open(linkToTable);
            }}
          >
            <OpenFile /> Åpne tabell i ny fane
          </Link>
          <DownloadFile data={props.selectedTable} />
        </div>
        <Table striped bordered hover className="CustomTable mt-3 mb-3">
          <TableHeader
            handleVariationChange={handleVariationChange}
            headerItems={headerItems}
          />
          <tbody>
            {tableSections}
            {mainSummaryRow &&
              mainSummaryRow.rows.map((row, index) => {
                return (
                  <SummaryRow
                    key={index}
                    data={row}
                    name={
                      mainSummaryRow.name && index === 0
                        ? mainSummaryRow.name
                        : ''
                    }
                  />
                );
              })}
          </tbody>
        </Table>
        <Description description={tableData.description} />
        <Relations relations={tableData.relationships} />
        <span>
          {language(tableData.language, 'source')}: {tableData.source}
        </span>
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    tableData: state.table.table
  };
};

export default connect(mapStateToProps, { fetchTable })(TableInstance);
